export default function LogoMark({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" data-testid="logo-mark">
      <rect x="2" y="2" width="44" height="44" rx="12" fill="hsl(var(--primary))" />
      <path d="M15 15.5h9.2c3.4 0 5.7 1.9 5.7 4.9 0 2-1.1 3.4-2.8 4.1 2.3.7 3.7 2.4 3.7 4.8 0 3.4-2.6 5.2-6.2 5.2H15v-19zm8.8 7.7c1.8 0 2.9-1 2.9-2.6s-1.1-2.5-2.9-2.5h-5.4v5.1h5.4zm1 8.8c2 0 3.1-1.1 3.1-2.8 0-1.8-1.2-2.8-3.1-2.8h-6.4v5.6h6.4z" fill="white" />
      <circle cx="35.5" cy="15.5" r="2.6" fill="hsl(var(--accent-gold))" fillOpacity="0.95" />
    </svg>
  );
}
